import { FLOW_MODES } from '@avanta/shared/constants/appointments';
import { FIFTEEN_MINUTES } from '@avanta/shared/constants/common';
import { type Treatment } from '@avanta/shared/types/appointments';
import { useQuery, type UseQueryResult } from '@tanstack/react-query';
import { useFormContext, useWatch } from 'react-hook-form';
import { QUERY_KEYS } from 'constants/common';
import { AppointmentsReservePayload } from 'pages/AppointmentsReserve/constants';
import { type AppointmentsReserveFormData } from 'pages/AppointmentsReserve/types';
import { AppointmentService } from 'services/appointments';

export const useFetchTreatments = (): UseQueryResult<Treatment[]> => {
  const { control } = useFormContext<AppointmentsReserveFormData>();
  const [flow, psychologist, contractId, patient] = useWatch({
    control,
    name: [
      AppointmentsReservePayload.flow,
      AppointmentsReservePayload.psychologist,
      AppointmentsReservePayload.contractId,
      AppointmentsReservePayload.patient,
    ],
  });
  const patientId = patient?.id ?? '';
  const psychologistId = psychologist?.id ?? '';
  return useQuery({
    queryKey: [QUERY_KEYS.FETCH_TREATMENTS, psychologistId, contractId, patientId],
    queryFn: () =>
      AppointmentService.getTreatments({
        ...(psychologistId && { psychologistId }),
        contractId,
        patientId,
      }),
    select: response => response.data,
    staleTime: FIFTEEN_MINUTES,
    enabled: flow !== FLOW_MODES.search_facultative && !!contractId && !!patientId,
  });
};
